/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminEbayCategorySuggestion,
    AdminEbayCategorySuggestionFromJSON,
    AdminEbayCategorySuggestionFromJSONTyped,
    AdminEbayCategorySuggestionToJSON,
} from './AdminEbayCategorySuggestion';

/**
 * 
 * @export
 * @interface AdminEbayCategorySuggestionsResp
 */
export interface AdminEbayCategorySuggestionsResp {
    /**
     * 
     * @type {Array<AdminEbayCategorySuggestion>}
     * @memberof AdminEbayCategorySuggestionsResp
     */
    items: Array<AdminEbayCategorySuggestion>;
}

export function AdminEbayCategorySuggestionsRespFromJSON(json: any): AdminEbayCategorySuggestionsResp {
    return AdminEbayCategorySuggestionsRespFromJSONTyped(json, false);
}

export function AdminEbayCategorySuggestionsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayCategorySuggestionsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AdminEbayCategorySuggestionFromJSON)),
    };
}

export function AdminEbayCategorySuggestionsRespToJSON(value?: AdminEbayCategorySuggestionsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(AdminEbayCategorySuggestionToJSON)),
    };
}

